// extracted by mini-css-extract-plugin
export var compactFilters = "_g1-4";
export var detailImage = "_g1-1";
export var dropdownContainer = "_g1-2";
export var imageContainer = "_g1-0";
export var selectedCard = "_g1-3";